import { CircularProgress, Paper, Stack } from '@mui/material'

type LoadingStateProps = {
    minHeight?: number | string
}

const LoadingState = ({ minHeight = 300 }: LoadingStateProps) => {
    return (
        <Paper elevation={0} sx={{ p: 4, borderRadius: 3, boxShadow: '0px 8px 24px rgba(15,15,15,0.06)' }}>
            <Stack alignItems="center" justifyContent="center" minHeight={minHeight}>
                <CircularProgress size={32} />
            </Stack>
        </Paper>
    )
}

export default LoadingState

